module.exports = __webpack_public_path__ + "img/thumb_29.37a2ac6a.jpg";